import { render, staticRenderFns } from "./PopupButton.vue?vue&type=template&id=245204dc&"
import script from "./PopupButton.vue?vue&type=script&lang=js&"
export * from "./PopupButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports